module.exports = __webpack_public_path__ + "static/media/designPatent_30-1030669.3a8cd1e9.png";